class SaturationDTO {
  saturation: number;
  currentHus: number;
  maxCapacity: number;

  constructor(res: any = {}) {
    const data = res?.data ?? {};

    this.saturation = res?.saturation ?? data?.saturation_percentage ?? 0;
    this.currentHus = data?.current_hus ?? 0;
    this.maxCapacity = data?.max_capacity ?? 0;
  }
}

export default SaturationDTO;
